import { useState, useEffect } from 'react';
import { useAuth } from './contexts/AuthContext';
import Home from './screens/Home';
import Login from './screens/Login';

type Screen = 'login' | 'home';

export default function App() {
    const { isLoggedIn, isLoading } = useAuth();
    const [currentScreen, setCurrentScreen] = useState<Screen>('login');

    // Inicialização: define tela correta baseada no estado de auth
    useEffect(() => {
        if (!isLoading) {
            const initialScreen = isLoggedIn ? 'home' : 'login';
            setCurrentScreen(initialScreen);
        }
    }, [isLoggedIn, isLoading]);

    // Gerencia redirecionamento baseado no estado de autenticação
    useEffect(() => {
        if (isLoggedIn && currentScreen !== 'home') {
            // Usuário logou com sucesso, redireciona para home
            setCurrentScreen('home');
        } else if (!isLoggedIn && currentScreen !== 'login') {
            // Usuário fez logout ou não está autenticado, redireciona para login
            setCurrentScreen('login');
        }
    }, [isLoggedIn, currentScreen]);

    // Mostra loading enquanto verifica autenticação
    if (isLoading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
                <div className="text-center">
                    <div className="text-4xl mb-4">⏳</div>
                    <p className="text-xl text-gray-700 font-medium">Verificando autenticação...</p>
                </div>
            </div>
        );
    }

    const renderScreen = () => {
        switch (currentScreen) {
            case 'login':
                return <Login onLoginSuccess={() => setCurrentScreen('home')} />;
            case 'home':
                return <Home />;
            default:
                return <Login onLoginSuccess={() => setCurrentScreen('home')} />;
        }
    };
    
    return (
        <div>
            {renderScreen()}
        </div>
    );
}
